import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { lookupTableGetRequest } from "../../../_redux/_actions/";

import {
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import CreateLookUpTableForm from "./forms/CreateLookUpTableForm";
import { FORM_TYPE_ADD, FORM_TYPE_EDIT } from "../../../_helpers/constants";

export default function EditLookupTable() {
     const { id } = useParams();
     const actionDispatch = useDispatch();

     useEffect(() => {
          actionDispatch(lookupTableGetRequest({ id }));
     }, []);

     const { details } = useSelector((state) => {
          return {
               details: state.lookupTable.details,
          };
     });

     return (
          <>
               <MainLeftTitle title="Update Lookup Table"></MainLeftTitle>
               <CreateLookUpTableForm
                    type={FORM_TYPE_EDIT}
                    initialValues={{
                         id: details.id,
                         name: details.name,
                        // typeId: details.typeId,
                         active: details.active,
                         labels: details.labels,
                    }}
               />
          </>
     );
}
